export default "__VITE_ASSET__luzuZ70W__";